import SiteReference from '@/models/SiteReference';
import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators'
import api from '@/api/api';
import SearchResult from '@/models/SearchResult';
import { SearchType } from '@/models/SearchType';

@Module
export default class SearchResults extends VuexModule {
  // searchTerms = new Array<string>();

  currentSearch = <SearchResult> {
    siteRefs: new Array<SiteReference>(),
    searchTerms: new Array<string>(),
    searchType: SearchType.Keyword
  };

  @Mutation
  mutateSearchResults(search: SearchResult) {
    this.currentSearch = search;
  }

  @Action({ commit: 'mutateSearchResults' })
  async doKeywordSearch(query: string) {
    const siteRefs  = await api.getSitesWithKeyword(query);
    return {
      searchTerms: query.split(" "),
      siteRefs,
      searchType: SearchType.Keyword
    };
  }

  @Action({ commit: 'mutateSearchResults' })
  async setSearchResults(search: SearchResult) {
    return search;
  }

}
